/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-14 10:36.
 */
const children = [
  {
    id: 'MemberInfo',
    parentId: 'MemberCenter',
    siteId: 50,
    code: 'MemberInfo',
    name: '会员信息',
    selected: false,
    path: 'member_info',
    url: '/member/member-info.html',
    orderNo: 0,
    articleModelFile: null,
    text: '会员信息',
    children: [],
    pageSize: null,
    isHeader: false,
    showCover: false,
    showContent: false,
    simpleArticleDtos: null,
    isStick: false,
    isPdf: false,
    isShow: false,
    modelFile: null
  }, {
    id: 'ActivityManage',
    parentId: 'MemberCenter',
    siteId: 50,
    code: 'ActivityManage',
    name: '活动管理',
    selected: false,
    path: 'activity_manage',
    url: '/member/activity-manage.html',
    orderNo: 1,
    articleModelFile: null,
    text: '活动管理',
    children: [],
    pageSize: null,
    isHeader: false,
    showCover: false,
    showContent: false,
    simpleArticleDtos: null,
    isStick: false,
    isPdf: false,
    isShow: false,
    modelFile: null
  }, {
    id: 'MySubmission',
    parentId: 'MemberCenter',
    siteId: 50,
    code: 'MySubmission',
    name: '我的投稿',
    selected: false,
    path: 'my_submission',
    url: '/member/my-submission.html',
    orderNo: 1,
    articleModelFile: null,
    text: '我的投稿',
    children: [],
    pageSize: null,
    isHeader: false,
    showCover: false,
    showContent: false,
    simpleArticleDtos: null,
    isStick: false,
    isPdf: false,
    isShow: false,
    modelFile: null
  }, {
    id: 'StaffInfo',
    parentId: 'MemberCenter',
    siteId: 50,
    code: 'StaffInfo',
    name: '人员信息',
    selected: false,
    path: 'staff_info',
    url: '/member/staff-info.html',
    orderNo: 1,
    articleModelFile: null,
    text: '人员信息',
    children: [],
    pageSize: null,
    isHeader: false,
    showCover: false,
    showContent: false,
    simpleArticleDtos: null,
    isStick: false,
    isPdf: false,
    isShow: false,
    modelFile: null
  }, {
    id: 'InvoiceInformation',
    parentId: 'MemberCenter',
    siteId: 50,
    code: 'InvoiceInformation',
    name: '发票管理',
    selected: false,
    path: 'invoice_information',
    url: '/member/invoice-information.html',
    orderNo: 1,
    articleModelFile: null,
    text: '发票管理',
    children: [],
    pageSize: null,
    isHeader: false,
    showCover: false,
    showContent: false,
    simpleArticleDtos: null,
    isStick: false,
    isPdf: false,
    isShow: false,
    modelFile: null
  }
];
const data = {
  id: 'MemberCenter',
  parentId: 'root',
  siteId: 50,
  code: 'MemberCenter',
  name: '会员中心',
  selected: false,
  path: '.MemberCenter.',
  url: '/member/message-center.html',
  orderNo: 3,
  articleModelFile: null,
  text: '会员中心',
  children: [],
  pageSize: null,
  isHeader: null,
  showCover: null,
  showContent: null,
  simpleArticleDtos: null,
  isStick: null,
  isPdf: null,
  isShow: false,
  modelFile: null
};

const messageCenter = [ {
  id: 'MessageCenter',
  parentId: 'MemberCenter',
  siteId: 50,
  code: 'MessageCenter',
  name: '系统消息',
  selected: true,
  path: 'message_center',
  url: '/member/message-center.html',
  orderNo: 1,
  articleModelFile: null,
  text: '系统消息',
  children: [],
  pageSize: null,
  isHeader: false,
  showCover: false,
  showContent: false,
  simpleArticleDtos: null,
  isStick: false,
  isPdf: false,
  isShow: false,
  modelFile: null
} ];

function initMenu( code, attach = {}, attachRoot = {} ) {
  let newChildren = [];
  if (code === 'MessageCenter') {
    newChildren = messageCenter
  } else {
    newChildren = children.map( item => {
      let newChild = item;
      if (code === item.code) {
        newChild = {
          ...item, ...attach,
          selected: true
        };
      }
      return newChild;
    } );
  }
  return {
    ...data,
    ...attachRoot,
    children: newChildren
  };
}

module.exports = { initMenu };
